const HELFERLINE_GROUP_ORDER = ['einrichtungsservice', 'service_plus'];

class HelferlineOverlay extends HTMLElement {
  connectedCallback() {
    this.flowModal = this.querySelector('[data-helferline-flow]');
    this.stepPanels = Array.from(this.querySelectorAll('[data-helferline-step]'));
    this.stepIndicators = Array.from(this.querySelectorAll('[data-helferline-step-indicator]'));
    this.stepperWrap = this.querySelector('[data-helferline-stepper-wrap]');
    this.titleEl = this.querySelector('[data-helferline-flow-title]');
    this.introEl = this.querySelector('[data-helferline-intro]');
    this.groupsEl = this.querySelector('[data-helferline-groups]');
    this.nextButton = this.querySelector('[data-helferline-next]');
    this.skipButton = this.querySelector('[data-helferline-skip]');
    this.backButton = this.querySelector('[data-helferline-back]');
    this.confirmButton = this.querySelector('[data-helferline-confirm]');
    this.errorEl = this.querySelector('[data-helferline-error]');
    this.confirmErrorEl = this.querySelector('[data-helferline-confirm-error]');
    this.summarySingleEl = this.querySelector('[data-helferline-summary-single]');
    this.summaryDualEl = this.querySelector('[data-helferline-summary-dual]');
    this.summaryService = this.querySelector('[data-helferline-summary-service]');
    this.summaryMetaLabel = this.querySelector('[data-helferline-summary-meta-label]');
    this.summaryMetaValue = this.querySelector('[data-helferline-summary-meta-value]');
    this.summaryPrice = this.querySelector('[data-helferline-summary-price]');
    this.warningEl = this.querySelector('[data-helferline-warning]');
    this.warningContentEl = this.querySelector('[data-helferline-warning-content]');
    this.warningTextEl = this.querySelector('[data-helferline-warning-text]');
    this.accordionEl = this.querySelector('[data-helferline-accordion-single]');
    this.accordionTitleEl = this.querySelector('[data-helferline-accordion-title]');
    this.accordionDescEl = this.querySelector('[data-helferline-accordion-desc]');
    this.accordionContentEl = this.querySelector('[data-helferline-accordion-content]');
    this.accordionsWrapEl = this.querySelector('[data-helferline-accordions]');
    this.accordionTemplate = this.querySelector('[data-helferline-accordion-template]');

    this.step = 1;
    this.isLocked = false;
    this.isConfirming = false;
    this.selectedKeys = this.createEmptySelectedKeys();
    this.productTitle = '';
    this.offers = null;
    this.openInfoKey = null;
    this.isClosing = false;
    this.pendingCheckout = null;
    this.addCompleted = false;

    this.onNext = this.onNext.bind(this);
    this.onSkip = this.onSkip.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onGroupsClick = this.onGroupsClick.bind(this);
    this.onFormSubmitCapture = this.onFormSubmitCapture.bind(this);
    this.onCartUpdate = this.onCartUpdate.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onModalHide = this.onModalHide.bind(this);

    this.nextButton?.addEventListener('click', this.onNext);
    this.skipButton?.addEventListener('click', this.onSkip);
    this.backButton?.addEventListener('click', this.onBack);
    this.confirmButton?.addEventListener('click', this.onConfirm);
    this.groupsEl?.addEventListener('change', this.onRadioChange);
    this.groupsEl?.addEventListener('click', this.onGroupsClick);
    this.flowModal?.addEventListener('modal:afterHide', this.onModalHide);
    document.addEventListener('submit', this.onFormSubmitCapture, true);
    document.addEventListener('click', this.onDocumentClick);

    this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
      theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate
    );
  }

  disconnectedCallback() {
    this.nextButton?.removeEventListener('click', this.onNext);
    this.skipButton?.removeEventListener('click', this.onSkip);
    this.backButton?.removeEventListener('click', this.onBack);
    this.confirmButton?.removeEventListener('click', this.onConfirm);
    this.groupsEl?.removeEventListener('change', this.onRadioChange);
    this.groupsEl?.removeEventListener('click', this.onGroupsClick);
    this.flowModal?.removeEventListener('modal:afterHide', this.onModalHide);
    document.removeEventListener('submit', this.onFormSubmitCapture, true);
    document.removeEventListener('click', this.onDocumentClick);
    this.cartUpdateUnsubscriber?.();
  }

  createEmptySelectedKeys() {
    return { einrichtungsservice: '', service_plus: '' };
  }

  getOffers() {
    if (this.offers) return this.offers;

    const script = this.querySelector('[data-helferline-offers]');
    if (!script) {
      this.offers = { einrichtungsservice: null, service_plus: null };
      return this.offers;
    }

    try {
      this.offers = JSON.parse(script.textContent);
    } catch (error) {
      console.error('Helferline overlay: invalid offers JSON', error);
      this.offers = { einrichtungsservice: null, service_plus: null };
    }

    return this.offers;
  }

  get cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  hasServicePlusInCart() {
    return (
      document.querySelector(
        '[id^="CartDrawer-Item"][data-service-plus="true"], [id^="CartItem-"][data-service-plus="true"]'
      ) !== null
    );
  }

  hasVorOrtEinrichtungsserviceInCart() {
    return (
      document.querySelector(
        '[id^="CartDrawer-Item"][data-vor-ort-einrichtungsservice="true"], [id^="CartItem-"][data-vor-ort-einrichtungsservice="true"]'
      ) !== null
    );
  }

  getBridgeForForm(form) {
    if (!form) return null;
    const wrapper = form.closest('.product-form-wrapper');
    return wrapper?.querySelector('[data-helferline-upsell="true"]') || null;
  }

  getFormId(form) {
    // Usercentrics can override HTMLFormElement#id with a non-string object.
    if (!form) return '';
    const attrId = form.getAttribute?.('id');
    if (attrId) return attrId;
    return typeof form.id === 'string' ? form.id : '';
  }

  getCashbackTrigger(form) {
    const formId = this.getFormId(form);
    if (!formId) return null;

    return (
      document.querySelector(
        `cashback-banner[data-product-form-id="${formId}"], cashback-button[data-product-form-id="${formId}"]`
      ) || null
    );
  }

  getCashbackCartItem(form, mainVariantId) {
    const trigger = this.getCashbackTrigger(form);
    if (!trigger || typeof trigger.getCartItem !== 'function') return null;
    return trigger.getCartItem(mainVariantId);
  }

  getVisibleGroups() {
    const offers = this.getOffers();
    const hideEinrichtung = this.hasVorOrtEinrichtungsserviceInCart();
    const hideServicePlus = this.hasServicePlusInCart();
    const groups = [];

    if (!hideEinrichtung && offers.einrichtungsservice?.products?.length) {
      groups.push({ key: 'einrichtungsservice', ...offers.einrichtungsservice });
    }

    if (!hideServicePlus && offers.service_plus?.products?.length) {
      groups.push({ key: 'service_plus', ...offers.service_plus });
    }

    return groups;
  }

  shouldIntercept(form) {
    if (this.isLocked) return false;
    if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
      return false;
    }

    if (form.closest('cart-drawer')) return false;

    const bridge = this.getBridgeForForm(form);
    if (!bridge) return false;

    if (this.hasVorOrtEinrichtungsserviceInCart() && this.hasServicePlusInCart()) return false;

    return this.getVisibleGroups().length > 0;
  }

  onFormSubmitCapture(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('is') !== 'product-form') return;
    if (!this.shouldIntercept(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const bridge = this.getBridgeForForm(form);
    const variantInput =
      form.querySelector('[name="id"]:not([data-cashback-input])') ||
      form.querySelector('[data-cashback-input="items-0-id"]') ||
      form.querySelector('[name="id"]');
    const quantityInput =
      form.querySelector('[name="quantity"]:not([data-cashback-input])') ||
      form.querySelector('[data-cashback-input="items-0-quantity"]') ||
      form.querySelector('[name="quantity"]');
    const formId = this.getFormId(form);
    const submitButton =
      form.querySelector('[type="submit"]') ||
      (formId ? document.querySelector(`[type="submit"][form="${formId}"]`) : null);

    const variantId = Number(variantInput?.value || bridge?.dataset.variantId || 0);
    const quantity = Number(quantityInput?.value || 1) || 1;

    if (!variantId) return;

    this.isLocked = true;
    this.addCompleted = false;
    this.productTitle = bridge?.dataset.productTitle || '';
    this.pendingCheckout = {
      variantId,
      quantity,
      form,
      submitButton,
      activeElement: submitButton,
      cashbackItem: this.getCashbackCartItem(form, variantId)
    };

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('aria-busy', 'true');
    }

    this.open();
  }

  onCartUpdate() {
    if (!this.flowModal?.open || this.isConfirming) return;

    requestAnimationFrame(() => {
      const hadSelection = this.hasAnySelection();
      const groups = this.syncVisibleGroups();

      if (!groups.length) {
        this.closeAndAddMainOnly();
        return;
      }

      if (hadSelection && !this.hasAnySelection() && this.step === 2) {
        this.setStep(1);
      }

      this.syncNextButton();
    });
  }

  open() {
    this.selectedKeys = this.createEmptySelectedKeys();
    this.openInfoKey = null;
    this.clearErrors();
    this.clearCardSelection();
    this.renderIntro();
    this.syncVisibleGroups();
    this.syncNextButton();
    this.setStep(1);
    this.flowModal?.show(this.pendingCheckout?.activeElement || null);
  }

  closeAndAddMainOnly() {
    this.finalizeCheckout({ includeService: false });
  }

  closeWithoutAdd() {
    this.pendingCheckout = null;
    this.addCompleted = true;
    this.closeModal();
  }

  closeModal() {
    if (this.isClosing) return;

    if (this.flowModal?.open) {
      this.isClosing = true;
      this.flowModal.hide();
      return;
    }

    this.finishClose();
  }

  onModalHide() {
    if (!this.addCompleted && this.pendingCheckout && !this.isConfirming) {
      this.finalizeCheckout({ includeService: false, modalAlreadyClosing: true });
      return;
    }

    if (this.addCompleted) {
      this.finishClose();
    }
  }

  finishClose() {
    const button = this.pendingCheckout?.submitButton;
    this.isLocked = false;
    this.isConfirming = false;
    this.isClosing = false;
    this.selectedKeys = this.createEmptySelectedKeys();
    this.openInfoKey = null;
    this.setConfirmBusy(false);
    this.pendingCheckout = null;
    this.addCompleted = false;

    if (button) {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  renderIntro() {
    if (!this.introEl) return;
    const template = this.dataset.step1Description || '';
    this.introEl.textContent = template
      .replace(/\{\{\s*product_title\s*\}\}/g, this.productTitle || '')
      .replace(/\[product_title\]/g, this.productTitle || '');
  }

  getProductKey(product) {
    return `${product.type}:${product.variantId}`;
  }

  hasAnySelection() {
    return HELFERLINE_GROUP_ORDER.some((key) => Boolean(this.selectedKeys[key]));
  }

  getSelectedEntries() {
    const offers = this.getOffers();
    const entries = [];

    HELFERLINE_GROUP_ORDER.forEach((groupKey) => {
      const selectedKey = this.selectedKeys[groupKey];
      if (!selectedKey) return;

      const group = offers[groupKey];
      if (!group?.products?.length) return;

      const product = group.products.find((item) => this.getProductKey(item) === selectedKey);
      if (product) entries.push({ product, group, groupKey });
    });

    return entries;
  }

  getSelectionMode() {
    const count = this.getSelectedEntries().length;
    if (count === 0) return 'none';
    if (count === 2) return 'dual';
    return 'single';
  }

  getSelectedProduct() {
    const entries = this.getSelectedEntries();
    return entries[0] || null;
  }

  getGroupKeyFromInput(input) {
    return input?.closest('[data-helferline-group]')?.dataset.helferlineGroup || '';
  }

  syncVisibleGroups() {
    if (!this.groupsEl) return [];

    const offers = this.getOffers();
    const hideEinrichtung = this.hasVorOrtEinrichtungsserviceInCart();
    const hideServicePlus = this.hasServicePlusInCart();
    const visibleGroups = [];

    this.groupsEl.querySelectorAll('[data-helferline-group]').forEach((groupEl) => {
      const key = groupEl.dataset.helferlineGroup;
      const offer = offers?.[key];
      const hasProducts = Boolean(offer?.products?.length);
      const hideByCart =
        (key === 'einrichtungsservice' && hideEinrichtung) ||
        (key === 'service_plus' && hideServicePlus);
      const hidden = !hasProducts || hideByCart;

      groupEl.hidden = hidden;

      if (!hidden) {
        visibleGroups.push({ key, ...offer });
      } else if (this.selectedKeys[key]) {
        this.selectedKeys[key] = '';
        this.clearCardSelection(key);
      } else {
        this.clearCardSelection(key);
      }
    });

    HELFERLINE_GROUP_ORDER.forEach((key) => {
      if (!this.selectedKeys[key]) return;
      const selectedInput = this.findServiceInput(this.selectedKeys[key]);
      const selectedGroup = selectedInput?.closest('[data-helferline-group]');
      if (!selectedInput || selectedGroup?.hidden) {
        this.selectedKeys[key] = '';
        this.clearCardSelection(key);
      }
    });

    this.syncCardSelection();

    const panel = this.groupsEl.querySelector('[data-helferline-groups-panel]');
    if (panel) panel.hidden = visibleGroups.length === 0;

    return visibleGroups;
  }

  findServiceInput(offerKey) {
    if (!this.groupsEl || !offerKey) return null;
    return (
      Array.from(this.groupsEl.querySelectorAll('[data-helferline-offer-radio]')).find(
        (input) => input.value === offerKey
      ) || null
    );
  }

  clearCardSelection(groupKey = null) {
    if (!this.groupsEl) return;

    this.groupsEl.querySelectorAll('[data-helferline-card]').forEach((card) => {
      const groupEl = card.closest('[data-helferline-group]');
      const cardGroupKey = groupEl?.dataset.helferlineGroup;
      if (groupKey && cardGroupKey !== groupKey) return;

      card.classList.remove('is-selected');
      const input = card.querySelector('[data-helferline-offer-radio]');
      if (input) input.checked = false;
    });
  }

  syncCardSelection() {
    if (!this.groupsEl) return;

    this.groupsEl.querySelectorAll('[data-helferline-card]').forEach((card) => {
      const groupEl = card.closest('[data-helferline-group]');
      const groupKey = groupEl?.dataset.helferlineGroup || '';
      const input = card.querySelector('[data-helferline-offer-radio]');
      const isSelected = Boolean(input && input.value === this.selectedKeys[groupKey]);
      card.classList.toggle('is-selected', isSelected);
      if (input) input.checked = isSelected;
    });
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  formatOfferPrice(product, group) {
    if (product.type === 'service_plus' && group.priceSuffix) {
      return `${product.price} ${group.priceSuffix}`.trim();
    }
    return product.price || '';
  }

  getWarningProductTitle(product) {
    if (product.type === 'service_plus') {
      return product.displayTitle || product.title || '';
    }
    return product.title || '';
  }

  getWarningBody(group) {
    const detail = String(group.warningDetail || '').trim();
    if (detail) return detail;
    return String(group.warning || '').trim();
  }

  renderPlzAccordionContent(leftHtml, rightHtml, contentEl = this.accordionContentEl) {
    if (!contentEl) return;

    const left = String(leftHtml || '').trim();
    const right = String(rightHtml || '').trim();
    if (!left && !right) {
      contentEl.replaceChildren();
      return;
    }

    const list = document.createElement('div');
    list.className = 'helferline-flow__plz-list';

    [left, right].forEach((html) => {
      if (!html) return;
      const col = document.createElement('div');
      col.className = 'helferline-flow__plz-col';
      col.innerHTML = html;
      list.appendChild(col);
    });

    contentEl.replaceChildren(list);
  }

  fillAccordionEntry(accordionEl, { product, group }) {
    if (!accordionEl) return;

    const titleBaseEl = accordionEl.querySelector('.helferline-flow__accordion-title-base');
    const titleSuffixEl = accordionEl.querySelector('.helferline-flow__accordion-title-suffix');
    const descEl = accordionEl.querySelector('.helferline-flow__accordion-desc');
    const contentEl = accordionEl.querySelector('.helferline-flow__accordion-content');
    const productTitle = this.getWarningProductTitle(product);
    const baseTitle = group.accordionTitle || '';

    if (titleBaseEl) titleBaseEl.textContent = baseTitle;
    if (titleSuffixEl) {
      titleSuffixEl.textContent = productTitle ? ` · ${productTitle}` : '';
      titleSuffixEl.hidden = !productTitle;
    }

    const isPlz = product.type === 'einrichtungsservice';
    accordionEl.classList.toggle('helferline-flow__accordion--plz', isPlz);

    if (isPlz) {
      if (descEl) {
        descEl.textContent = group.accordionDescription || '';
        descEl.hidden = !group.accordionDescription;
      }
      this.renderPlzAccordionContent(group.accordionHtml, group.accordionHtmlRight, contentEl);
    } else {
      const accordionDescription = product.accordionDescription || product.bulletsText || '';
      if (descEl) {
        descEl.textContent = accordionDescription;
        descEl.hidden = !accordionDescription;
      }
      if (contentEl) {
        contentEl.innerHTML = product.accordionInfoHtml || '';
      }
    }

    accordionEl.open = false;
  }

  createSummaryRow(label, value, { price = false } = {}) {
    const row = document.createElement('div');
    row.className = 'helferline-flow__summary-row';
    if (price) row.classList.add('helferline-flow__summary-row--price');

    const labelEl = document.createElement('span');
    labelEl.className = 'helferline-flow__summary-label';
    labelEl.textContent = label;

    const valueEl = document.createElement('span');
    valueEl.className = 'helferline-flow__summary-value';
    valueEl.textContent = value;

    row.append(labelEl, valueEl);
    return row;
  }

  renderDualSummary(entries) {
    if (!this.summaryDualEl) return;

    const serviceLabel = this.dataset.summaryServiceLabel || 'Service';
    const priceLabel = this.dataset.summaryPriceLabel || 'Preis';
    const heading = this.dataset.summaryHeading || 'Ihre Auswahl';

    const fragment = document.createDocumentFragment();
    const headingEl = document.createElement('p');
    headingEl.className = 'helferline-flow__summary-heading';
    headingEl.textContent = heading;
    fragment.appendChild(headingEl);

    const body = document.createElement('div');
    body.className = 'helferline-flow__summary-dual-body';

    entries.forEach((entry, index) => {
      const { product, group } = entry;
      const block = document.createElement('div');
      block.className = 'helferline-flow__summary-block';

      const groupTitle = document.createElement('p');
      groupTitle.className = 'helferline-flow__summary-group-title';
      groupTitle.textContent = group.summaryGroupTitle || '';
      block.appendChild(groupTitle);

      block.appendChild(
        this.createSummaryRow(serviceLabel, this.getWarningProductTitle(product))
      );

      if (product.type === 'einrichtungsservice') {
        block.appendChild(this.createSummaryRow(group.metaLabel || '', group.metaValue || ''));
      } else {
        const metaLabel = group.metaLeistungLabel || 'Leistung';
        block.appendChild(
          this.createSummaryRow(metaLabel, product.bulletsText || group.metaValue || '')
        );
      }

      block.appendChild(
        this.createSummaryRow(priceLabel, this.formatOfferPrice(product, group), { price: true })
      );

      body.appendChild(block);

      if (index < entries.length - 1) {
        const divider = document.createElement('div');
        divider.className = 'helferline-flow__summary-divider';
        divider.setAttribute('aria-hidden', 'true');
        body.appendChild(divider);
      }
    });

    const einrichtungEntry = entries.find(({ product }) => product.type === 'einrichtungsservice');
    const servicePlusEntry = entries.find(({ product }) => product.type === 'service_plus');

    if (einrichtungEntry && servicePlusEntry) {
      const divider = document.createElement('div');
      divider.className = 'helferline-flow__summary-divider';
      divider.setAttribute('aria-hidden', 'true');
      body.appendChild(divider);

      const total = document.createElement('div');
      total.className = 'helferline-flow__summary-total';

      const totalLabelWrap = document.createElement('div');
      totalLabelWrap.className = 'helferline-flow__summary-total-labels';

      const totalLabel = document.createElement('p');
      totalLabel.className = 'helferline-flow__summary-total-label';
      totalLabel.textContent = this.dataset.summaryTotalLabel || 'Gesamt';

      const totalNote = document.createElement('p');
      totalNote.className = 'helferline-flow__summary-total-note';
      totalNote.textContent = this.dataset.summaryTotalNote || '';

      totalLabelWrap.append(totalLabel, totalNote);

      const totalAmounts = document.createElement('div');
      totalAmounts.className = 'helferline-flow__summary-total-amounts';

      const totalPrimary = document.createElement('p');
      totalPrimary.className = 'helferline-flow__summary-total-primary';
      totalPrimary.textContent = einrichtungEntry.product.price || '';

      const totalSubline = document.createElement('p');
      totalSubline.className = 'helferline-flow__summary-total-subline';
      const monthlyLineTemplate = this.dataset.summaryTotalMonthlyLine || 'einmalig, zzgl. {price}';
      const monthlyPrice = this.formatOfferPrice(servicePlusEntry.product, servicePlusEntry.group);
      totalSubline.textContent = monthlyLineTemplate.replace(/\{price\}/g, monthlyPrice);

      totalAmounts.append(totalPrimary, totalSubline);
      total.append(totalLabelWrap, totalAmounts);
      body.appendChild(total);
    }

    fragment.appendChild(body);
    this.summaryDualEl.replaceChildren(fragment);
  }

  renderDualWarning(entries) {
    if (!this.warningEl || !this.warningContentEl) return;

    this.warningContentEl.replaceChildren();

    entries.forEach(({ product, group }) => {
      const body = this.getWarningBody(group);
      if (!body) return;

      const paragraph = document.createElement('p');
      const title = this.getWarningProductTitle(product);
      const strong = document.createElement('strong');
      strong.textContent = `${title}:`;
      paragraph.append(strong, ` ${body}`);
      this.warningContentEl.appendChild(paragraph);
    });

    const checkoutNote = String(this.dataset.warningCheckoutNote || '').trim();
    if (checkoutNote) {
      const paragraph = document.createElement('p');
      paragraph.textContent = checkoutNote;
      this.warningContentEl.appendChild(paragraph);
    }

    this.warningEl.hidden = this.warningContentEl.childElementCount === 0;
  }

  renderSingleWarning({ group }) {
    if (!this.warningEl || !this.warningContentEl) return;

    const warning = group.warning || '';
    this.warningContentEl.replaceChildren();

    const paragraph = document.createElement('p');
    paragraph.setAttribute('data-helferline-warning-text', '');
    paragraph.textContent = warning;
    this.warningTextEl = paragraph;
    this.warningContentEl.appendChild(paragraph);
    this.warningEl.hidden = !warning;
  }

  renderDualAccordions(entries) {
    if (!this.accordionsWrapEl || !this.accordionTemplate) return;

    this.accordionsWrapEl.replaceChildren();

    entries.forEach((entry) => {
      const accordionEl = this.accordionTemplate.content
        .querySelector('details')
        .cloneNode(true);
      this.fillAccordionEntry(accordionEl, entry);
      this.accordionsWrapEl.appendChild(accordionEl);
    });
  }

  renderSingleStep2({ product, group }) {
    if (this.summarySingleEl) this.summarySingleEl.hidden = false;
    if (this.summaryDualEl) this.summaryDualEl.hidden = true;
    if (this.accordionEl) this.accordionEl.hidden = false;
    if (this.accordionsWrapEl) {
      this.accordionsWrapEl.hidden = true;
      this.accordionsWrapEl.replaceChildren();
    }

    const price = this.formatOfferPrice(product, group);

    if (this.summaryService) {
      this.summaryService.textContent = this.getWarningProductTitle(product);
    }
    if (this.summaryMetaLabel) this.summaryMetaLabel.textContent = group.metaLabel || '';
    if (this.summaryMetaValue) {
      this.summaryMetaValue.textContent =
        product.type === 'service_plus' ? group.metaValue || '' : group.metaValue || '';
    }
    if (this.summaryPrice) this.summaryPrice.textContent = price;

    this.renderSingleWarning({ group });

    if (this.accordionTitleEl) this.accordionTitleEl.textContent = group.accordionTitle || '';
    const suffixEl = this.accordionEl?.querySelector('.helferline-flow__accordion-title-suffix');
    if (suffixEl) {
      suffixEl.textContent = '';
      suffixEl.hidden = true;
    }

    this.fillAccordionEntry(this.accordionEl, { product, group });
  }

  onRadioChange(event) {
    const input = event.target.closest('[data-helferline-offer-radio]');
    if (!input) return;

    const groupKey = this.getGroupKeyFromInput(input);
    if (!groupKey) return;

    this.selectedKeys[groupKey] = input.value;
    this.clearErrors();
    this.syncCardSelection();
    this.syncNextButton();
  }

  onGroupsClick(event) {
    const infoButton = event.target.closest('[data-helferline-info]');
    if (infoButton) {
      event.preventDefault();
      event.stopPropagation();

      const key = infoButton.dataset.helferlineInfo;
      const popover = infoButton.querySelector('.helferline-flow__info-popover');
      const isOpen = this.openInfoKey === key;

      this.closeAllInfo();
      if (!isOpen && popover) {
        popover.hidden = false;
        infoButton.setAttribute('aria-expanded', 'true');
        infoButton.classList.add('is-open');
        this.openInfoKey = key;
      }
      return;
    }

    const card = event.target.closest('[data-helferline-card]');
    if (!card || !this.groupsEl?.contains(card)) return;

    const input = card.querySelector('[data-helferline-offer-radio]');
    if (!input) return;

    const groupKey = this.getGroupKeyFromInput(input);
    if (!groupKey) return;

    // Radios cannot be unchecked natively — re-clicking the selected card clears it.
    if (this.selectedKeys[groupKey] !== input.value) return;

    event.preventDefault();
    this.selectedKeys[groupKey] = '';
    this.clearErrors();
    this.syncCardSelection();
    this.syncNextButton();
  }

  onDocumentClick(event) {
    if (!this.openInfoKey) return;
    if (event.target.closest('[data-helferline-info]')) return;
    this.closeAllInfo();
  }

  closeAllInfo() {
    const root = this.flowModal || this;
    root.querySelectorAll('[data-helferline-info]').forEach((button) => {
      button.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      const popover = button.querySelector('.helferline-flow__info-popover');
      if (popover) popover.hidden = true;
    });
    this.openInfoKey = null;
  }

  syncNextButton() {
    if (!this.nextButton) return;
    const disabled = !this.hasAnySelection();
    this.nextButton.disabled = disabled;
    if (disabled) this.nextButton.setAttribute('aria-disabled', 'true');
    else this.nextButton.removeAttribute('aria-disabled');
  }

  setStep(step) {
    this.step = step;
    this.closeAllInfo();

    this.stepPanels.forEach((panel) => {
      panel.hidden = Number(panel.dataset.helferlineStep) !== step;
    });

    this.stepIndicators.forEach((indicator) => {
      const indicatorStep = Number(indicator.dataset.helferlineStepIndicator);
      indicator.classList.toggle('is-active', indicatorStep === step);
      indicator.classList.toggle('is-complete', indicatorStep < step);
    });

    this.stepperWrap?.classList.toggle('is-step-2', step === 2);

    const title = this.dataset[`titleStep${step}`] || '';
    if (this.titleEl && title) this.titleEl.textContent = title;

    if (step === 2) this.renderStep2();
  }

  renderStep2() {
    const entries = this.getSelectedEntries();
    if (!entries.length) {
      this.setStep(1);
      return;
    }

    const mode = this.getSelectionMode();

    if (mode === 'dual') {
      if (this.summarySingleEl) this.summarySingleEl.hidden = true;
      if (this.summaryDualEl) this.summaryDualEl.hidden = false;
      if (this.accordionEl) this.accordionEl.hidden = true;
      if (this.accordionsWrapEl) this.accordionsWrapEl.hidden = false;

      this.renderDualSummary(entries);
      this.renderDualWarning(entries);
      this.renderDualAccordions(entries);
      return;
    }

    this.renderSingleStep2(entries[0]);
  }

  onNext(event) {
    event.preventDefault();
    if (!this.hasAnySelection()) return;
    this.clearErrors();
    this.setStep(2);
  }

  onBack(event) {
    event.preventDefault();
    this.clearErrors();
    this.setStep(1);
  }

  onSkip(event) {
    event.preventDefault();
    this.finalizeCheckout({ includeService: false });
  }

  async onConfirm(event) {
    event.preventDefault();
    if (this.isConfirming) return;

    const entries = this.getSelectedEntries();
    if (!entries.length) return;

    for (const { product } of entries) {
      if (product.type === 'service_plus' && !product.sellingPlanId) {
        this.showConfirmError(this.dataset.errorMessage || '');
        return;
      }
    }

    await this.finalizeCheckout({
      includeService: true,
      serviceProducts: entries.map(({ product }) => product)
    });
  }

  async finalizeCheckout({
    includeService = false,
    serviceProducts = null,
    modalAlreadyClosing = false
  } = {}) {
    if (this.isConfirming || this.addCompleted) return;
    if (!this.pendingCheckout?.variantId) {
      this.addCompleted = true;
      if (!modalAlreadyClosing) this.closeModal();
      else this.finishClose();
      return;
    }

    this.isConfirming = true;
    this.setConfirmBusy(true);
    this.clearErrors();

    const freshCashback = this.getCashbackCartItem(
      this.pendingCheckout.form,
      this.pendingCheckout.variantId
    );
    if (freshCashback?.id) {
      this.pendingCheckout.cashbackItem = freshCashback;
    }

    const items = [
      {
        id: Number(this.pendingCheckout.variantId),
        quantity: Number(this.pendingCheckout.quantity) || 1
      }
    ];

    const cashbackItem = this.pendingCheckout.cashbackItem;
    if (cashbackItem?.id) {
      items.push({
        ...cashbackItem,
        parent_id: Number(this.pendingCheckout.variantId)
      });
    }

    const services = includeService && serviceProducts?.length ? serviceProducts : [];
    services.forEach((serviceProduct) => {
      const serviceItem = {
        id: Number(serviceProduct.variantId),
        quantity: 1
      };
      if (serviceProduct.sellingPlanId) {
        serviceItem.selling_plan = Number(serviceProduct.sellingPlanId);
      }
      items.push(serviceItem);
    });

    const itemsWithoutServices = cashbackItem?.id
      ? [items[0], { ...cashbackItem, parent_id: Number(this.pendingCheckout.variantId) }]
      : [items[0]];

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const response = await fetch(theme.routes.cart_add_url, {
        ...theme.utils.fetchConfig('javascript'),
        body: JSON.stringify({
          items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });
      const parsedState = await response.json();

      if (parsedState.status) {
        if (includeService && services.length > 0) {
          await this.addItemsOnly(itemsWithoutServices);
          this.addCompleted = true;
          if (!modalAlreadyClosing) this.closeModal();
          else this.finishClose();
          window.setTimeout(() => this.cartDrawer?.show?.(this.pendingCheckout?.activeElement || null), 80);
          return;
        }

        this.showConfirmError(parsedState.description || this.dataset.errorMessage || '');
        this.isConfirming = false;
        this.setConfirmBusy(false);
        return;
      }

      const cartJson = await (
        await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
      ).json();
      cartJson.sections = parsedState.sections;

      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'helferline-overlay',
        productVariantId: this.pendingCheckout.variantId,
        cart: cartJson
      });

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState, source: 'helferline-overlay' }
        })
      );

      this.addCompleted = true;
      const activeElement = this.pendingCheckout?.activeElement || null;

      if (this.pendingCheckout?.cashbackItem) {
        this.getCashbackTrigger(this.pendingCheckout.form)?.clearSelection?.();
      }

      if (!modalAlreadyClosing && this.flowModal?.open) {
        this.isClosing = true;
        this.flowModal.hide();
      } else {
        this.finishClose();
      }

      window.setTimeout(() => this.cartDrawer?.show?.(activeElement), 100);
    } catch (error) {
      console.error(error);
      this.showConfirmError(this.dataset.errorMessage || '');
      this.isConfirming = false;
      this.setConfirmBusy(false);
    }
  }

  async addItemsOnly(items) {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    const response = await fetch(theme.routes.cart_add_url, {
      ...theme.utils.fetchConfig('javascript'),
      body: JSON.stringify({
        items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname
      })
    });
    const parsedState = await response.json();
    if (parsedState.status) return parsedState;

    const cartJson = await (
      await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
    ).json();
    cartJson.sections = parsedState.sections;

    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'helferline-overlay',
      productVariantId: items[0]?.id,
      cart: cartJson
    });

    return parsedState;
  }

  setConfirmBusy(busy) {
    if (!this.confirmButton) return;
    if (busy) {
      this.confirmButton.setAttribute('aria-disabled', 'true');
      this.confirmButton.setAttribute('aria-busy', 'true');
      this.confirmButton.disabled = true;
      return;
    }
    this.confirmButton.removeAttribute('aria-disabled');
    this.confirmButton.removeAttribute('aria-busy');
    this.confirmButton.disabled = false;
  }

  showConfirmError(message) {
    if (!this.confirmErrorEl) return;
    this.confirmErrorEl.hidden = !message;
    this.confirmErrorEl.textContent = message || '';
  }

  clearErrors() {
    if (this.errorEl) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }
    if (this.confirmErrorEl) {
      this.confirmErrorEl.hidden = true;
      this.confirmErrorEl.textContent = '';
    }
  }
}

customElements.define('helferline-overlay', HelferlineOverlay);
